import { StorageKeys, storageService } from '@/utils/localStorageService'

/**
 * The operator's token, as the browser holds it.
 *
 * localStorage rather than a cookie or a login screen, deliberately: this is one shared secret for a
 * console two people use, the same secret the edge password used to be, and it is typed once per
 * machine. A session/user model would be the right answer to a different question — one nobody has
 * asked yet — and building it now would delay closing a live leak.
 *
 * It is NOT a security boundary on the client. The boundary is the service, which checks the header
 * on every request; this file only decides what gets sent.
 */
export const operatorToken = (): string =>
  (storageService.getItem<string>(StorageKeys.operatorToken) ?? '').trim()

export const setOperatorToken = (value: string) => {
  const token = value.trim()
  if (token) storageService.setItem(StorageKeys.operatorToken, token)
  else storageService.removeItem(StorageKeys.operatorToken)
}

export const hasOperatorToken = (): boolean => Boolean(operatorToken())
